/* eslint-disable prefer-arrow/prefer-arrow-functions */

import { ClassType } from '../lib/utils';
import { tryRegisterExtensionMethod } from './extensions-util';

export function Extension<T, K extends keyof T>(classType: ClassType<T>, functionName: K) {
  return function (target: any, propertyName: string, descriptor: TypedPropertyDescriptor<Function>) {
    tryRegisterExtensionMethod(classType.prototype, functionName, function (...args) {
      return descriptor.value(this, ...args);
    });
  };
}
